{
  "version": 1,
  "asset_id": "5bf9e8f4-87dc-4f62-9356-eb6e0e1ebda3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5bf9e8f4-87dc-4f62-9356-eb6e0e1ebda3/sleeve-normal-revision-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5bf9e8f4-87dc-4f62-9356-eb6e0e1ebda3/sleeve-normal-revision-480.webp",
  "original_filename": "sleeve-normal-revision-480.webp",
  "size": 25586,
  "content_type": "image/webp",
  "created_at": "2026-10-05T01:21:33Z"
}
